module.exports = __webpack_public_path__ + "img/71_26.c1772f9b.png";